<template lang='pug'>
  .linkable-button.layout(:class='contentAlignment')
    a(:href='content.attributes["link_url"]')
      button.btn.btn-default(
        v-text='content.attributes["label_text"]'
      )
</template>
<script>
import { Content } from '../../props'
export default {
  props: {
    content: { type: Content, default: () => new Content({}) }
  },
  computed: {
    contentAlignment () {
      return this.content.attributes.alignment
    }
  }
}
</script>
<style lang='scss' scoped>
.layout {
  width: 100%;
  display: flex;

  margin-bottom: 10px;
}

// contentAligment will add respective class to the button so it
// is rendered according to the property.
.left {
  justify-content: flex-start;
}

.right {
  justify-content: flex-end;
}

.center {
  justify-content: center;
}
</style>
